import { useEffect } from 'react'
import { useCreateUploadGrantMutation } from '@/core/services/file'
import { getMagicLinkSuccess } from '@/redux/reducers/auth.reducer'
import { useAppDispatch } from '@/redux/rootReducer'

/**
 * Pre-mints a scoped upload grant for the patient's documents and stores the
 * resulting shortened magic link so the QR dialog can render it. The link grants
 * ONLY "upload a file to this patient" — it no longer issues a doctor session.
 */
export function useGenerateFileUploadQRCode(patientId?: string) {
  const dispatch = useAppDispatch()
  const [createUploadGrant] = useCreateUploadGrantMutation()

  useEffect(() => {
    if (!patientId) return
    createUploadGrant({ objectType: 'patient', objectId: patientId })
      .unwrap()
      .then(({ url }) => dispatch(getMagicLinkSuccess(url)))
      .catch(() => undefined)
  }, [patientId, dispatch, createUploadGrant])
}
